export const ReportErrorsPrefix = '[report error]'

export interface LoggerBase {
  log<T extends unknown[]>(...args: T): void
  warn<T extends unknown[]>(...args: T): void
  error<T extends unknown[]>(...args: T): void
}

export class Logger implements LoggerBase {
  private customLogger: LoggerBase | undefined

  initializeWithCustom(logger: LoggerBase): void {
    this.customLogger = logger
  }

  log<T extends unknown[]>(...args: T): void {
    if (this.customLogger) {
      this.customLogger.log(...args)
    } else {
      // eslint-disable-next-line no-console
      console.log(...args)
    }
  }

  warn<T extends unknown[]>(...args: T): void {
    if (this.customLogger) {
      this.customLogger.warn(...args)
    } else {
      // eslint-disable-next-line no-console
      console.warn(...args)
    }
  }

  error<T extends unknown[]>(...args: T): void {
    if (this.customLogger) {
      this.customLogger.error(...args)
    } else {
      // eslint-disable-next-line no-console
      console.error(...args)
    }
  }
}

export const logger = new Logger()
